import React, { Fragment } from 'react';
import Collapsible from 'react-collapsible';
import ContainerHeader from 'components/ContainerHeader';
import BasicDetailRow from 'components/basicDetailRow';

/**
 * Pass in an array that has the format
 * const entries = [
    {
        name: 'name 1',
        drillDownData: [
            { label: 'label 1', description: 'description 1' },
            { label: 'label 2', description: 'description 2' },
            { label: 'label 3', description: 'description 3' }
        ]
    },
    {
        name: 'name 2',
        drillDownData: [
            { label: 'label 1', description: 'description 1' },
            { label: 'label 2', description: 'description 2' },
            { label: 'label 3', description: 'description 3' }
        ]
    }
];
 * @param {Array} Array of objects that contain the keys, name: string and drillDownData: array
 */
const MultiDetailDrillDown = ({ entries, title }) => {
    if (entries && Array.isArray(entries) && entries.length > 0) {
        return (
            <Fragment>
                {title ?
                    <ContainerHeader title={title} />
                    :
                    null
                }
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12">
                        {entries.map((entry, index) => {
                            return (
                                <Collapsible trigger={entry?.name} key={index} triggerStyle={{ afterTop: 2, backgroundColor: 'black', paddingTop: 8, paddingBottom: 8 }}>
                                    <div className="col-sm-12 text-center text-sm-left">
                                        <table className="default-table table table-sm table-responsive-sm table-hover">
                                            <tbody>
                                                {entry?.drillDownData.map((drillDown) => {
                                                    return (
                                                        <BasicDetailRow label={drillDown?.label} description={drillDown?.description} />
                                                    );
                                                }
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Collapsible>
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    } else {
        return (
            <div className="row">
                <div className="col-md-12 col-12">
                    <Fragment>
                        <ContainerHeader title={title} />
                        <div className="mr-auto">
                            <h3 className="card-heading">No entries found here</h3>
                        </div>
                    </Fragment>
                </div>
            </div>
        );
    }
};

export default MultiDetailDrillDown;


// WEBPACK FOOTER //
// ./components/multiDetailDrillDown/index.js